import { Toggle } from "../../../ui/toggle/toggle";
import { rootActions, useAppDispatch, useAppSelector } from "../DAL/store";
import React from "react";
import { getFilteredItems } from "../services/logic-helper";
import { sendGAEvent } from "../../../domain/marketing/gtm-provider";
import { HIDE_MY_PRODUCTS_SESSION_STORAGE_KEY } from "../../list-page/services/list-page-provider";
import { getIsAuthenticated } from "../../../domain/hidden-data-provider";


export const ProductsOwnToggle = () => {

    const dispatch = useAppDispatch();

    const hideProductsOwn = useAppSelector(store => store.hideProductsOwn);
    const purchased = useAppSelector(store => store.purchased);
    const PageData = useAppSelector(store => store.PageData);
    const filterTerm = useAppSelector(store => store.filterTerm);
    /**
     * apply products I own toggle change
     */
    const onToggleChange = (isChecked: boolean) => {
        const isUserLoggedIn = getIsAuthenticated();
        if (!isUserLoggedIn) {
            //show login popup
            dispatch(
                rootActions.main({
                    isLoggedInForFreePlugin: false,
                    showLoginPage: true
                })
            );
            return;
        }
        let filteredItems = getFilteredItems(isChecked, purchased, PageData.freePlugins, filterTerm);

        dispatch(
            rootActions.main({
                filteredItems: filteredItems,
                hideProductsOwn: isChecked
            })
        );

        sendGAEvent('JPList', `Products I Have: ${isChecked ? 'Hide' : 'Show'}`);
        window.sessionStorage.setItem(HIDE_MY_PRODUCTS_SESSION_STORAGE_KEY, isChecked + '');
    };
    return (
        <div className="flex items-center">
            <div className="text-tiny md:text-sm text-gray-500 mr-4 whitespace-nowrap">Products I have</div>
            <div className="mr-4">
                <Toggle
                    isChecked={ hideProductsOwn }
                    onChange={ onToggleChange }
                    text={ hideProductsOwn ? 'Hide' : 'Show'}
                    isPositionRight={true}
                    textStyles={{
                        margiLeft: '-5px',
                        marginTop: '2px',
                    }}/>
            </div>
        </div>
    )
};

/*
<div className="flex items-center">

    <div className="flex items-center justify-center text-sm md:text-base px-2">
        {/!*<div className={`${!hideProductsOwn ? "font-bold" : ""}`}>Show</div>*!/}
        <div className="mx-2">
            <Toggle
                isChecked={hideProductsOwn}
                onChange={onToggleChange}
                text={hideProductsOwn ? 'Hide' : 'Show'}
                textStyles={{
                    margiLeft: '-5px'
                }}/>
        </div>
        {/!*<div className={`${hideProductsOwn ? "font-bold" : ""}`}>Hide</div>*!/}
    </div>

</div>*/
